import { createSlice } from '@reduxjs/toolkit';
import { isObject } from 'lodash';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
    VehiclesState,
    SetVehiclesPayload,
    UpdateVehiclePayload,
    AddVehiclePayload,
    RemoveVehicleByIdPayload
} from './types';

const initialState: VehiclesState = {};

export const vehiclesSlice = createSlice({
    name: 'vehicles',
    initialState,
    reducers: {
        setVehicles: (state, action: PayloadAction<SetVehiclesPayload>) => {
            return action.payload;
        },
        updateVehicle: (state, action: PayloadAction<UpdateVehiclePayload>) => {
            const { id, data } = action.payload;
            if (!isObject(data)) return state;
            return { ...state, [id]: data };
        },
        addVehicle: (state, action: PayloadAction<AddVehiclePayload>) => {
            const vehicle = action.payload;
            const { id } = vehicle;
            return { ...state, [id]: vehicle };
        },
        removeVehicleById: (
            state,
            action: PayloadAction<RemoveVehicleByIdPayload>
        ) => {
            const { payload: id } = action;

            if (state[id]) {
                delete state[id];
            }

            return state;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialState;
        });
    }
});
export const { addVehicle, setVehicles, updateVehicle, removeVehicleById } =
    vehiclesSlice.actions;

export const selectVehicles = (state: RootState) => state.vehicles;

export const selectVehicleById = (vehicleId?: string) => (state: RootState) => {
    if (!vehicleId) return undefined;
    return state.vehicles[vehicleId];
};

export default vehiclesSlice.reducer;
